import { render } from "./ProfileDataComponent.vue?vue&type=template&id=245f9274&scoped=true"
import script from "./ProfileDataComponent.vue?vue&type=script&lang=js"
export * from "./ProfileDataComponent.vue?vue&type=script&lang=js"

import "@/styles/ProfileDataComponent.css?vue&type=style&index=0&id=245f9274&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245f9274"]])

export default __exports__